export default "__VITE_ASSET__XopYP6Ia__"